import React from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import moment from 'helpers/moment'
import PersonIcon from '@mui/icons-material/Person'
import Tooltip from '@mui/material/Tooltip'
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import HomeworkFiles from "./homework-files"

const useStyles = makeStyles(homeworkBodyStyles)

export default function HomeworksBody({context}) {

  const classes = useStyles()
  const history = useHistory()
  const {query, translate, link, linkQuery, homeworkContext, groups, profile} = context

  const order = query.orderBy ? (query.orderBy.startsWith('-') ? 'desc' : 'asc') : undefined
  const orderBy = order ? (order == 'asc' ? query.orderBy : query.orderBy.substring(1)) : undefined

  function formatDate(date) {
    return moment(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY')
  }

  function formatTime (date) {
    return moment(date).format('hh:mm A')
  }

  function editHomework(homework) {
    context.updateState({
      homeworkContext: {
        createHomework: {
          open: {$set: true}, 
          editing: {$set: true}, 
          editState: {$set: homework}
        }
      }
    })
  }

  function deleteHomework(homework) {
    context.updateState({
      homeworkContext: {
        deleteHomework: {
          open: {$set: true},
          homework: {$set: homework}
        }
      }
    })
  }

  
  return (
    <TableBody>
      {homeworkContext.homeworks.items.map((row) => {
        const group = groups.find(x=> x.id == row.group) || {}
        
        return (
        <TableRow key={row.id} className={classes.row}>  
          {/* <TableCell align="left">{formatDate(row.created)}</TableCell> */}
          <TableCell align="left" className={classes.title}>{row.title}</TableCell>
          {/* <TableCell align="left">Curso</TableCell> */}
          <TableCell align="left"><span className={clsx(classes.group)}>{group.name}</span></TableCell>
          <TableCell align="center">
            <div className={clsx(classes.startDate, classes.dateCell)}>
              <div className="date">
                {formatDate(row.startDate)}
              </div>
              <div className="time">
                {formatTime(row.startDate)}
              </div>
            </div>
          </TableCell>
          <TableCell align="center">
            <div className={clsx(classes.endDate, classes.dateCell)}>
              <div className="date">
                {formatDate(row.endDate)}
              </div>
              <div className="time">
                {formatTime(row.endDate)}
              </div>
            </div>
          </TableCell>
          <TableCell align="center"><span className={clsx(classes.score)}>{row.properties.score}</span></TableCell>
          <TableCell align="center">
            <span className={clsx(classes.files)}>
              <HomeworkFiles context={context} passport={profile.Passport.id} files={row.properties.files} />
            </span>
          </TableCell> 
          <TableCell className={classes.students} align="center">
            <Tooltip title={translate('view-homework-tooltip')}>
              <Link to={link({page: 'homework', homeworkId: row.id})} className={clsx(classes.link, classes.textLink)}>
                {row.turnIns} / {row.students.length} 
                <PersonIcon className={classes.personIcon} />
              </Link>
            </Tooltip>
          </TableCell>
          <TableCell className={classes.actions} style={{top:92}} align="right">            
            <Tooltip title={translate('edit-homework-tooltip')}>
              <span onClick={()=> editHomework(row)} className={clsx(classes.link, classes.editLink)}>
                <FontAwesomeIcon icon={faEdit} />
              </span>
            </Tooltip>
             <Tooltip title={translate('delete-homework-tooltip')}>
              <span onClick={()=> deleteHomework(row)} className={clsx(classes.link, classes.deleteLink)}>
                <FontAwesomeIcon icon={faTrash} />
              </span>
            </Tooltip>
          </TableCell>
        </TableRow>
      )}
      )}
    </TableBody>

  )
}


function homeworkBodyStyles() {
    return {
        title: {
          paddingLeft: 33,
        },
        row: {
          color: '#4f576e'
        },
        actions: {
          width: 100,
          minWidth: 100
        },
        visuallyHidden: {
          border: 0,
          clip: 'rect(0 0 0 0)',
          height: 1,
          margin: -1,
          overflow: 'hidden',
          padding: 0,
          position: 'absolute',
          top: 20,
          width: 1,
        },
        personIcon: {
          color: '#009dd8',
          position: 'relative',
          top: 5,
          left: 6
        },
        textLink: {
          color: '#009dd8',
          fontSize: '12pt !important',
          marginRight: 20,
          cursor: 'pointer',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline'
          }
        },
        link: {
          color: '#009dd8',
          fontSize: '16pt',
          marginRight: 20,
          cursor: 'pointer'
        },
        deleteLink: {
          fontSize: '15.5pt',
          color: '#e56666'
        },
        group: {
        },
        score: {
          marginLeft: '-15px'
        },
        dateCell: {
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          fontSize: '0.875rem',
          "& .date": {
            display: 'flex',
            justifyContent: 'flex-start',
            marginRight: 10
          },
          "& .time": {
            display: 'flex',
            justifyContent: 'flex-end'

          }
        },
        files: {
          marginLeft: '-10px'
        }
      };
}
